module.exports = __webpack_public_path__ + "assets/img/ibm-watson.070b36ee.png";